/**
 * 华为 OBS 文件相关接口
 */
import request from '@/axios/axios'

/**
 * MD5 检查接口（支持秒传 / 断点续传）
 * @param {{ md5: string, originFileName: string, obsEnums: string }} obj
 *   obsEnums 可用值: OTA, LOG
 * @returns {Promise}
 *   resultType:
 *   - file_exists：文件已存在（秒传），返回 fileInfo
 *   - resume_upload：可断点续传，返回 resumeInfo { uploadId, urlMap, completedPartETags }
 *   - file_not_exists：文件未上传，需走初始化分片
 */
export function checkFileMD5(obj) {
  return request({
    url: 'ota/obs/file/check-md5',
    method: 'post',
    data: obj
  })
}

/**
 * 初始化分片上传，返回 uploadId 和每个分片对应的预签名上传地址
 * @param {{ md5: string, originFileName: string, size: number, obsEnums: string, chunkCount: number, chunkSize: number }} obj
 * @returns {Promise}
 */
export function initMultipartFile(obj) {
  return request({
    url: 'ota/obs/file/multipart/init',
    method: 'post',
    data: obj
  })
}

/**
 * 合并分片
 * @param {{ uploadId: string, partETags: Array<{ partNumber: number, etag: string }>, md5?: string, originFileName?: string, obsEnums?: string }} obj
 * @returns {Promise}
 */
export function mergeFileByMD5(obj = { uploadId: '', partETags: [] }) {
  return request({
    url: 'ota/obs/file/multipart/merge',
    method: 'post',
    data: obj
  })
}
